/*
BullShitFeedBackModal.js
BullShit反馈的Modal
 */
import React, {useState} from "react";
import {Modal, Input, Radio} from "antd";

import submitBullshitResponse from "../functions/submitBullshitResponse";

const BullShitFeedBackModal = ({open, setBullShitModalOpen, messages}) => {
    // 单选radio选择的选项
    const [radioValue, setRadioValue] = useState(1);
    const [inputValue, setInputValue] = useState('');

    // Input编辑
    const handleInputOnChange = (e) => {
        setInputValue(e.target.value);
    }

    // radio点选选择
    const handleRadioOnChange = (e) => {
        setRadioValue(e.target.value);
    };


    // 点击取消按钮
    const handleCancelClicked = () => {
        submitBullshitResponse({messages: messages, reasonCode: radioValue, reason: inputValue});
        setBullShitModalOpen(false);
    };

    // 点击确定按钮
    const handleOkClicked = () => {
        submitBullshitResponse({messages: messages, reasonCode: radioValue, reason: inputValue});
        setBullShitModalOpen(false);
    };

    // 所有的选项
    const options = [
        {
            value: 1,
            label: '与事实不符',
        },
        {
            value: 2,
            label: '犯懒',
        },
        {
            value: 3,
            label: '有偏见',
        },
        {
            value: 4,
            label: '不喜欢这种风格',
        },
        {
            value: 5,
            label: '没有帮助',
        },
        {
            value: 6,
            label: (
                <>
                    其他...
                    {radioValue === 6 && (
                        <Input
                            variant="filled"
                            placeholder="请输入原因"
                            onChange={handleInputOnChange}
                            style={{
                                maxWidth: 120,
                                marginInlineStart: 12,
                            }}
                        />
                    )}
                </>
            )
        },
    ];

    return (
        <Modal open={open} closable={false} title='请与我们分享更多信息:' onCancel={handleCancelClicked}
               onOk={handleOkClicked}>
            <Radio.Group onChange={handleRadioOnChange} options={options} value={radioValue}
                         style={{marginTop: 20, display: 'flex', flexDirection: 'column', gap: 15,}}/>
        </Modal>
    );
};

export default BullShitFeedBackModal;